const { OverlayScrollbars } = OverlayScrollbarsGlobal;

const initScrollbar = (selector, options = {}) => {
    let element = document.querySelector(selector);
    if (element) {
        return OverlayScrollbars(element, options);
    }
    console.warn(`Scrollbar not found =/ \nSelector: ${selector}`);
}

console.log(window.innerWidth)
if (window.innerWidth < 1024) {
    initScrollbar('.app--scrollbar-search');
    initScrollbar('.app--scrollbar-basket');
}

if (window.innerWidth < 640) {
    initScrollbar('.register__modal');
}
